import { View, ControlRow, Button, Icon } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { memo, type FC } from "react";

const CLOCK_ICON_SIZE = 18;

export interface AdjustControlProps {
  readonly scheduleTime: string;
  readonly onAdjust: () => void;
  readonly onAdjustOverride?: () => void;
  readonly statusText?: string;
  readonly hasActiveOverride?: boolean;
  readonly overrideAction?: "armed" | "disarmed";
}

export const AdjustControl: FC<AdjustControlProps> = memo(
  ({
    scheduleTime,
    onAdjust,
    onAdjustOverride,
    statusText = "Scheduled",
    hasActiveOverride = false,
    overrideAction,
  }) => {
    const { theme } = useUnistyles();

    const topLine =
      hasActiveOverride ?
        overrideAction === "armed" ?
          "Manually armed"
        : "Manually disarmed"
      : scheduleTime;
    const bottomLine = hasActiveOverride ? scheduleTime : statusText;

    return (
      <View bg="surface" style={styles.container}>
        <ControlRow
          icon={
            <Icon
              name="clockOutline"
              size={CLOCK_ICON_SIZE}
              color={theme.colors.interactive.controls.default_midground}
              style={{ top: -theme.spacing.sm }}
            />
          }
          title={topLine}
          subtitle={bottomLine}
          titleTextStyle="xxs/regular"
          subtitleTextStyle="xxs/regular"
          action={
            <Button
              label="Adjust"
              onPress={hasActiveOverride && onAdjustOverride ? onAdjustOverride : onAdjust}
              variant="primary"
              variantColor="grey"
            />
          }
        />
      </View>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    borderColor: theme.colors.border,
    borderWidth: 1,
    borderRadius: theme.spacing.lg,
    paddingVertical: theme.spacing.lg,
    paddingHorizontal: theme.spacing["3xl"],
    alignSelf: "stretch",
  },
}));
